/**
 * Layout for info box to be shown on empty data area
 */
import { CarouselLayout, Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { toBounds } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/utils';

export function emptyDataAreaInfoBoxArea(baseLayout: CarouselLayout, side: Side) {
  const dataArea = baseLayout.dataArea(side);
  const boxesArea = baseLayout.boxesArea(side);

  const margin = 6;

  const x1 = side === Side.RIGHT ? dataArea.x1 + margin : boxesArea.x1;
  const x2 = side === Side.RIGHT ? boxesArea.x2 : dataArea.x2 - margin;
  const y1 = dataArea.y1;
  const y2 = dataArea.y2;

  return toBounds({
    x1,
    x2,
    y1,
    y2,
  });
}
